import { render, staticRenderFns } from "./gatherCard.vue?vue&type=template&id=4e9456c0&scoped=true&"
import script from "./gatherCard.vue?vue&type=script&lang=js&"
export * from "./gatherCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9456c0",
  null
  
)

export default component.exports